window.__ENV = new URL(location).searchParams.get("env");